import React from 'react';
import Icon from '../ui/Icon';
import LevelBadge from './LevelBadge';
import XPBar from './XPBar';
import Streak from './Streak';
import { readinessLevelColor, readinessLevelLabel } from '../diagnostic/diagnosticHelpers';
import './PlayerJourneyHero.css';

// The Progress page's opening viewport: who am I, where am I, what am I
// working toward — Level/XP/Streak from the same real player-profile read
// as Home, plus the real readiness state/trend (never a fabricated
// "movement" — trend is whatever readinessEngine already computed).
const TREND = {
  improving: { icon: 'trend-up', text: 'Improving' },
  declining: { icon: 'trend-down', text: 'Declining' },
  stable: { icon: 'trend-flat', text: 'Holding steady' },
  insufficient_data: null,
};

const PlayerJourneyHero = ({ progress, readiness }) => {
  const trend = readiness?.available ? TREND[readiness.trend] : null;
  return (
    <div className="pjh-root">
      <div className="pjh-top">
        <LevelBadge level={progress.level} size="lg" />
        <div className="pjh-streak"><Streak streak={progress.streak} compact /></div>
      </div>
      <XPBar levelProgress={progress.levelProgress} />

      <div className="pjh-readiness">
        <span className="pjh-readiness-label">Placement Journey</span>
        {readiness?.available ? (
          <>
            <span className="pjh-readiness-value" style={{ color: readinessLevelColor(readiness.level) }}>
              {readinessLevelLabel(readiness.level)}
            </span>
            {trend && <span className="pjh-readiness-trend"><Icon name={trend.icon} size={14} /> {trend.text}</span>}
          </>
        ) : (
          <span className="pjh-readiness-value pjh-readiness-value--muted">Not enough evidence yet</span>
        )}
      </div>
    </div>
  );
};

export default PlayerJourneyHero;
